import React from 'react'

import styles from './ImpactSection.module.scss'
import ProtectionScoresSection from './ProtectionScoresSection'
import TimeSavedSection from './TimeSavedSection'

interface ImpactSectionProps {
  loading: boolean
  numUsersPerBucket?: Array<{ bucket: string; numUsers: number } | null>
  numUsersPerBucketPerConcernArea?: Array<{
    bucket: string
    numUsers: number
    concernArea: string
  } | null>
  timeSaved?: {
    total: number
    avgTimeSavedPerUser: number
  } | null
}

export default function ImpactSection({
  loading,
  numUsersPerBucket,
  numUsersPerBucketPerConcernArea,
  timeSaved,
}: ImpactSectionProps) {
  return (
    <div className={styles.container}>
      <ProtectionScoresSection
        loading={loading}
        numUsersPerBucket={numUsersPerBucket}
        numUsersPerBucketPerConcernArea={numUsersPerBucketPerConcernArea}
      />

      <TimeSavedSection loading={loading} timeSaved={timeSaved} />
    </div>
  )
}
